export const handleSuccessAlert = (setAlertData, message, onCloseCallback = undefined) => {
    setAlertData({
        severity: 'success',
        message: message,
        open: true,
        onCloseCallback,
    });
};
